import { useEffect, useState, useRef, act } from 'react';
import axios from 'axios';

import { AuthStatus, useAuth } from '../auth';
import { useLocation, useNavigate } from "react-router-dom";

import { set, useForm } from "react-hook-form";
import { Modal, Popover } from 'bootstrap';


import { ToastContainer, toast } from 'react-toastify';

import Toggle from 'react-toggle';


import NavBar from './navbar';
import Menu   from './menu';

import '../styles/features.scss';


const endpoint = process.env.REACT_APP_ENDPOINT;

const Features = () => {

    // Datos generales
    const status = AuthStatus();
    const { token } = useAuth();
    const location = useLocation();

    const contractType = location.state?.new;
    const featuresTypes = [
        { value: 'programacion', label: "Constancia de Programación de Vacaciones"},
        { value: 'disfrute',     label: "Constancia de Disfrute de Vacaciones"},
        { value: 'diferir',      label: "Constancia de Solicitud de Vacaciones"},
        { value: 'paternidad',   label: "Constancia de Disfrute de Licencia por Paternidad"},
        { value: 'anticipo',     label: "Anticipo de Salario"}
    ];

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
   
    const [collaborators, setCollaborators] = useState([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState([]);
   
    // Campos de form
    const [selectedCollaborator, setSelectedCollaborator] = useState(null);
   
    
    const { register, setValue, handleSubmit } = useForm();

    const mixtTitle = featuresTypes.find(type => type.value === contractType)?.label || "Mixto";
    const navigate = useNavigate();

    const onSubmit = async (data) => {
        if (!selectedCompany || !selectedCollaborator?.id) {
            toast.error('Selecciona una empresa y un colaborador antes de guardar.');
            return;
        }

        const payload = {
            tipo: contractType,
            company_id: selectedCompany.id,
            collaborator_id: selectedCollaborator.id,
            data
        };

        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.post(`${endpoint}admin/documents`, payload, config);
            toast.success('Documento creado exitosamente.');
            navigate('/admin/documents');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error al guardar el documento.');
        }
    };

    // Obtener empresas
    const fetchCompanies = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/companies`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCompanies(response.data);
            console.log(response.data);
            if (response.data.length > 0) {
                setSelectedCompany(response.data[0]); // Selecciona la primera empresa solo si no hay contrato existente
            }
        } catch (error) {
            toast.error('Error al obtener la lista de compañías');
        }
    };

    // Obtener colaboradores
    const fetchCollaborators = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/collaborators`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCollaborators(response.data);
        } catch (error) {
            toast.error('Error al obtener la lista de colaboradores');
        }
    };

    // Filtrar colaboradores cuando cambia la empresa seleccionada
    useEffect(() => {
        if (selectedCompany) {
            const filtered = collaborators.filter(col => col.company_id === selectedCompany.id);
            setFilteredCollaborators(filtered);
        
          
            if(selectedCompany && contractType === "anticipo"){
                setValue('representante',selectedCompany.representante_legal)
                
            }
        }
    }, [selectedCompany, collaborators]);

    //Obtener datos 
     useEffect(() => {
        fetchCompanies();
        fetchCollaborators();

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new Popover(popoverTriggerEl, {
                trigger: 'focus' // Se cierra cuando el usuario hace clic fuera
            });
        });
    }, [token]);

    const handleSelectCollaborator = (id)=>{
        let collaborator = collaborators.filter(c => c.id === Number(id))

        if(collaborator.length > 0){
            setSelectedCollaborator(collaborator[0])
            let altaDate = collaborator[0].created_at ? collaborator[0].created_at.split('T')[0] : ''
            setValue('alta', altaDate)
        }else{
            setSelectedCollaborator(null);
        }
    }

    const handleDiscard = ()=>{
        navigate('/admin/documents');
    }

    return(
        <div className="features">
            <NavBar auth={status} companies={companies} selected={selectedCompany} set={setSelectedCompany} />
            <div className='features-row'>
                <Menu />
                <form className='features-wrapper' onSubmit={handleSubmit(onSubmit)}>
                    <ToastContainer />
                    <h2>{ mixtTitle }</h2>
                    <div className='features-controls'>
                        <button type='button' className='btn btn-secondary' onClick={handleDiscard}>
                            Descartar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>

                    <strong>Datos del Trabajador</strong>
                    <div className="features-worker features-section">
                        <div className="c-select">
                            <label htmlFor="collaborator-select">Colaborador</label>
                            <select
                                required
                                id="collaborator-select"
                                value={selectedCollaborator ? selectedCollaborator.id : ''}
                                onChange={(e) => handleSelectCollaborator(e.target.value)}
                            >
                                <option value="">Selecciona una opción</option>
                                {filteredCollaborators.map(collaborator => (
                                    <option key={collaborator.id} value={collaborator.id}>
                                        { collaborator.nombre } { collaborator.apellidos } 
                                    </option>
                                ))}
                            </select>
                        </div>

                        {
                            (contractType === 'programacion' || contractType === 'disfrute' || contractType === 'diferir') && 
                            <div className="c-input">
                                <label htmlFor="alta">Fecha de Ingreso a Laborar</label>
                                <input type="date" 
                                    required
                                    id='alta'
                                    {...register("alta", { required: "Especifica fecha." })} 
                                />
                            </div>

                        }

                       
                    </div>

                    {
                        (contractType === 'programacion' || contractType === 'disfrute' || contractType === 'diferir') &&
                        <>
                            <strong>Respecto al Goce de Vacaciones</strong>
                            <div className="features-section">
                                <div className="c-input">
                                    <label htmlFor="dias">Númer de Días que le Corresponden</label>
                                    <input type="number" 
                                        required
                                        min="1"
                                        id='dias'
                                        {...register("dias", { required: "Especifica fecha." })} 
                                    />
                                </div>
                                <strong>
                                    {
                                        contractType === 'programacion' ? 
                                            'Días que se le Programan para Gozar' : 
                                            contractType === 'disfrute'  ?  'Días que se le Otorgarón y Gozó' :  'Vacaciones Solicitadas'
                                        
                                    }
                                </strong>
                                <div className="c-group">
                                    <div className="c-input">
                                        <label htmlFor="fecha_inicio">Fecha Inicio</label>
                                        <input type="date" 
                                            required
                                            id='fecha_inicio'
                                            {...register("fecha_inicio", { required: "Especifica fecha." })} 
                                        />
                                    </div>
                                    <div className="c-input">
                                        <label htmlFor="fecha_fin">Fecha Fin</label>
                                        <input type="date" 
                                            required
                                            id='fecha_fin'
                                            {...register("fecha_fin", { required: "Especifica fecha." })} 
                                        />
                                    </div>


                                </div>
                               
                                <div className="c-select">
                                    <label htmlFor="aniversario">Correspondientes al Aniversario</label>
                                    <select name="aniversario" id="aniversario" onChange={(e)=>(setValue('aniversario',Number(e.target.value)))}>
                                        {(() => {
                                            const actual = new Date().getFullYear();
                                            const limite =  actual;
                                            let inicio = actual;

                                            if (selectedCollaborator?.created_at) {
                                            const creacion = new Date(selectedCollaborator.created_at).getFullYear();
                                                inicio = Math.min(limite, actual, creacion);
                                            }

                                            const options = [];
                                            for (let year = limite; year >= inicio; year--) {
                                                options.push(<option key={year} value={year}>{year}</option>);
                                            }
                                            return options;
                                        })()}
                                    </select>
                                </div>

                                <div className="c-input">
                                    <label htmlFor="labores">Fecha de Regreso a Labores</label>
                                    <input type="date" 
                                        required
                                        id='labores'
                                        {...register("fecha_labores", { required: "Especifica fecha." })} 
                                    />
                                </div>



                            </div>
                        </>
                    }

                    {
                        contractType === 'paternidad' && 
                        <>
                            <strong>Respecto a la Licencia por Paternidad</strong>
                            <div className="features-section">
                                <strong>Periodo de Licencia</strong>
                                <div className="c-group">
                                    <div className="c-input">
                                        <label htmlFor="fecha_inicio">Fecha Inicio</label>
                                        <input type="date" 
                                            required
                                            id='fecha_inicio'
                                            {...register("fecha_inicio", { required: "Especifica fecha." })} 
                                        />
                                    </div>
                                    <div className="c-input">
                                        <label htmlFor="fecha_fin">Fecha Fin</label>
                                        <input type="date" 
                                            required
                                            id='fecha_fin'
                                            {...register("fecha_fin", { required: "Especifica fecha." })} 
                                        />
                                    </div>


                                </div>
                            </div>
                        </>
                    }

                    {
                        contractType === 'anticipo' && 
                        <>
                            <strong>Respecto al Anticipo</strong>
                            <div className="features-section">
                                <small>
                                    Este monto <b>No</b> puede ser mayor al <b>Salario Mensual</b> del Colaborador.
                                </small>
                                <div className="c-input">
                                    <label htmlFor="monto">Monto del Anticipo</label>
                                    <input type="number" 
                                        required
                                        id='monto'
                                        min="1"
                                        {...register("monto", { required: "Especifica monto." })} 
                                    />
                                </div>
                                <div className="c-input">
                                    <label htmlFor="letra">Monto del Anticipo en Letra</label>
                                    <input type="text" 
                                        required
                                        id='letra'
                                        min="1"
                                        {...register("letra", { required: "Especifica monto en letra." })} 
                                    />
                                </div>
                            </div>
                        </>
                    }

                    <strong>Datos de la Empresa/Patrón</strong>
                    <div className="features-section">
                        <div className="c-select">
                            <label htmlFor="companie-select">Empresa / Patrón</label>
                            
                            <p>{selectedCompany ? selectedCompany.nombre : '--'}</p>
                        </div>

                        {
                            contractType === 'anticipo' && 
                            <div className="c-input">
                                <label htmlFor="representante">Representante Legal</label>
                                <input type="text" 
                                    required
                                    id='representante'
                                    {...register("representante", { required: "Especifica representante." })} 
                                />
                            </div>
                        }
                    </div>

                    <strong>Datos del Acta</strong>
                    <div className="features-general features-section">
                        

                        <div className="c-input">
                            <label htmlFor="elaboracion">Fecha de Elaboración</label>
                            <input type="date" 
                                required
                                id='elaboracion'
                                {...register("elaboracion", { required: "Especifica fecha." })} 
                            />
                        </div>

                        {
                            (contractType === 'programacion' || contractType === 'diferir') &&
                            <div className="c-input">
                                <label htmlFor="recepcion">Fecha de Entrega / Recepción por Trabajador</label>
                                <input type="date" 
                                    required
                                    id='recepcion'
                                    {...register("recepcion", { required: "Especifica fecha." })} 
                                />
                            </div>
                        }
                        

                    </div>


                    
                  
                   
                   

                    <button id='submit' className='btn btn-primary'>
                        Crear documento
                    </button>
                </form>
            </div>
        </div>
    );

};

export default Features;
